import React from "react";
import CuadroListaEditable from "../edicion/CuadroListaEditable.js";
import * as Data from "../edicion/data/DataPersonaBoletines.js";
import * as DTOs from "../edicion/DTOs/BoletinesPersonaDTOs.js";
import * as Funciones from "../edicion/funciones/FuncionesBoletines.js";

const BoletinesPersona = (props) => {
  const idPersona = props.persona && props.persona.id;

  return (
    <CuadroListaEditable
      titulo="Boletines AFA"
      idPadre={idPersona}
      data={Data}
      dtos={DTOs}
      funciones={Funciones}
    />
  );
};

export default BoletinesPersona;
